import {IStateProps} from './model';
import * as React from 'react';
import {View} from 'react-native';
import {useStyles} from '../../../../../shared/hooks/styles';
import {ApplicationsFilter} from '../../../common/applicationsFilter';
import {Button} from '../../../../../shared/components/button';
import {images} from '../../../../../assets/icons';

export default ({handleSubmit, onSubmit, showFilter, toggleFilter, wrapRef}: IStateProps) => {
  const styles = useStyles(({theme, addShadow}) => ({
    container: {
      position: 'absolute',
      right: 0,
      zIndex: 3,
      top: 54,
    },
    wrapper: {
      position: 'relative',
    },
    filter: {
      width: 350,
      backgroundColor: theme.color.blue100,
      paddingTop: 0,
      ...addShadow({
        height: 8,
        radius: 25,
        opacity: 0.1,
      }),
      borderRadius: 5,
    },
    filterGroup: {
      paddingHorizontal: 15,
    },
    filterButton: {
      width: 140,
    },
  }));
  return (
    <View style={styles.wrapper} ref={wrapRef}>
      <Button
        id='profile-applications-filter'
        style={styles.filterButton}
        onPress={toggleFilter}
        text='Фильтр'
        type='secondary'
        iconPosition='right'
        icon={showFilter ? images.ArrowUp : images.ArrowDown}
        iconProps={{width: 20, height: 20}}
      />
      {showFilter ? (
        <View style={styles.container}>
          <ApplicationsFilter
            containerStyle={styles.filter}
            groupStyle={styles.filterGroup}
            showButton={true}
            onPressButton={() => {
              handleSubmit(onSubmit)();
              toggleFilter();
            }}
          />
        </View>
      ) : null}
    </View>
  );
};
